const tr = {
    all: '全部',
    mainBranch: '主分支',
    branchVersion: '分支版本',
    recordList: '記錄清單',  
    add: '添加',
    versionNum: '版本號',
    updateDesc: '更新說明',
    file: '文件(.apk)',
    downTips: '正在下載，請稍後。',
    downFailError: '下載失敗，{{error}}',
    addAppRecord: '添加APP發佈記錄',
    plFillInfo: '請將資訊填寫完整！',
    addSuccess:'添加成功',
    delApk: '刪除apk',
};

export default tr;